// changeOrders.ts — Step 3b. Change Order methods.
// See workers/core-os/src/routes/change_orders.ts (change_orders, 0008).

import { request } from './request'

export type ChangeOrderStatus =
  | 'proposed'
  | 'client_review'
  | 'signed'
  | 'executed'
  | 'rejected'
  | 'cancelled'

export interface ChangeOrderRow {
  id: string
  project_id: string
  commitment_id: string | null
  display_name: string
  description: string
  amount_cents: number
  affects_schedule: number | null
  schedule_impact_days: number | null
  status: ChangeOrderStatus
  client_signed_at: string | null
  created_at: string
  updated_at: string | null
}

export interface ChangeOrderListResponse {
  ok: true
  change_orders: ChangeOrderRow[]
  count: number
  summary: {
    committed_cents: number
    pending_cents: number
    schedule_impact_days: number
  }
}

export interface CreateChangeOrderInput {
  display_name: string
  description: string
  amount_cents: number
  affects_schedule?: boolean
  schedule_impact_days?: number
}

export interface PatchChangeOrderInput {
  status?: ChangeOrderStatus
  display_name?: string
  description?: string
  amount_cents?: number
  affects_schedule?: boolean
  schedule_impact_days?: number | null
}

export const changeOrdersApi = {
  list: (projectId: string) =>
    request<ChangeOrderListResponse>(
      `/api/projects/${encodeURIComponent(projectId)}/change-orders`,
    ),
  create: (projectId: string, body: CreateChangeOrderInput) =>
    request<{ ok: true; id: string; status: string; request_id: string }>(
      `/api/projects/${encodeURIComponent(projectId)}/change-orders`,
      { method: 'POST', body: JSON.stringify(body) },
    ),
  update: (projectId: string, coId: string, body: PatchChangeOrderInput) =>
    request<{ ok: true; id: string; updated: string[] }>(
      `/api/projects/${encodeURIComponent(projectId)}/change-orders/${encodeURIComponent(
        coId,
      )}`,
      { method: 'PATCH', body: JSON.stringify(body) },
    ),
}
